import React from 'react';
import ProductDetailApps from './ProductDetailApps';
import ProductDetailWeb from './ProductDetailWeb';

export default function ProductDetail() {
  const isApps = localStorage.getItem("PREVIEW_APPS") === "true";
  return isApps ? <ProductDetailApps /> : <ProductDetailWeb />;
}
